// ■ ホクレン加工食品システム用コンスト定義

// *****  構造体 *****
// 名称マスタの識別子
export const MeishoBunruiCd = {
  KA_FUKA_FLG: 'KI001', // 可・不可フラグ
  MUKO_FLG: 'KI002', // 無効フラグ
  HASU_KB: 'KI003', // 端数区分
  TAISHO_FLG: 'KI004', // 対象フラグ
  SUMI_FLG: 'KI005', // 済フラグ
  UMU_FLG: 'KI006', // 有無フラグ
  PB_KB: 'KI007', // PB区分
  SHUKKA_KB: 'KI008', // 出荷区分
  SHIYO_KB: 'KI009', // 使用区分
  KAINAI_KAIGAI_KB: 'KI010', // 会内会外区分
  RIYO_RANK: 'KI011', // 利用ランク
  HOSHU_KB: 'KI012', // 保守区分
  NAIBU_TORIHIKI_KB: 'KI013', // 精算内部取引区分
  KAISHU_SAITO_KIJUN: 'KI014', // 回収サイト算出基準
  OUTPUT_KB: 'KI015', // 出力区分
  TSUCHI_KB: 'KI016', // 通知区分
  SOKO_KOBETSU_KB: 'KI017', // 倉庫個別区分
  SHIIRESAKI_SOKO_HAISO_KB: 'KI018', // 仕入先倉庫配送区分
  JIGYOSHO_KB: 'KI019', // 事業所区分
  JUYO_FLG: 'KI020', // 重要フラグ
  ANBUN_KIJUN: 'KI021', // 按分基準
  TEKIYO_SHURUI_CD: 'KI022', // 摘要種類コード
  SAIBAN_CD: 'KI023', // 採番コード
  USER_HOSHU_KB: 'KI024', // ユーザ保守区分
  SHIIRESAKI_KB: 'KI025', // 仕入先区分
  FLG: 'KI026', // 汎用フラグ
  ONLINE_KB: 'KI027', // オンライン区分
  KASHOKU_TORIATSUKAI_KB: 'KI028', // 加食取扱区分
  NAIBU_TORIATSUKAI_KB: 'KI029', // 精算内部取扱区分
  IKAN_TORIHIKI_KB: 'KI030', // 移管取引区分
  SHIYO_GYOSHU_KB: 'KI031', // 使用業種区分
  SHOHIZEI_TORIHIKI_KB: 'KI032', // 消費税取引区分
  SHIWAKE_TEKIYO_BUNRUI_KB: 'KI033', // 仕訳摘要分類区分
  DATA_HASSEI_KB: 'KI034', // データ発生区分
  MEISAI_ZOKUSEI_KB: 'KI035', // 明細属性区分
  KAZEI_KB: 'KI036', // 課税区分
  UKEHARAI_TANI_KB: 'KI037', // 受払単位区分
  SHONIN_FLG: 'KI038', // 承認フラグ
  HATCHU_HAISO_KB: 'KI039', // 発注配送区分
  NYUSHUKKO_KB: 'KI040', // 入出庫区分
  HAISO_KB: 'KI041', // 配送区分
  SEIKYUSAKI_KB: 'KI042', // 請求先区分
  HIMMOKU_SHURUI_CD: 'KI043', // 品目種類コード
  UKE_HARAI_KB: 'KI044', // 受払区分
  HAISO_TEHAI_KB: 'KI045', // 配送手配区分
  LOG_KB: 'KI046', // ログ状況区分
  SHOMI_HYOJI_FLG: 'KI047', // 賞味期限表示フラグ
  SEIKYU_KB: 'KI048', // 請求区分
  TORIKESHI_FLG: 'KI049', // 取消フラグ
  ZEIRITSU_KB: 'KI050', // 税率区分
  UCHIWAKE_KB: 'KI051', // 内訳区分
  SOKO_KANRI_KB: 'KI052', // 倉庫管理区分
  DEKIDAKA_KB: 'KI053', // 出来高区分
  MAIL_ID: 'KI054', // メールID
  SHIIRE_NYUKO_KB: 'KI055', // 仕入入庫区分
  KOJO_JOTAI_KB: 'KI056', // 工場状態区分
  HIKIATE_KB: 'KI057', // 引当区分
  JUN_KB: 'KI058', // 旬区分
  HIKIATE_ERR_KB: 'KI059', // 引当エラー区分
  TEISEI_KB: 'KI060', // 訂正区分
  HENKO_KB: 'KI061', // 変更区分
  SHOGAKARI_KB: 'KI062', // 諸掛区分
  SHORI_KB: 'KI063', // 処理区分
  SHIHARAISAKI_KB: 'KI064', // 支払先区分
  ISO_MOTO_KB: 'KI065', // 移送元区分
  FILE_KEISHIKI: 'KI066', // ファイル形式
  DENSO_KEISHIKI: 'KI067', // 伝送形式
  SHONIN_KEKKA_KB: 'KI068', // 承認結果区分
  KEIJO_TANI_KB: 'KI069', // 計上単位区分
  KAKUNIN_KB: 'KI070', // 確認区分
  CALENDAR_SHIKIBETSU_CD: 'KI071', // カレンダー識別コード
  YOBI_CD: 'KI072', // 曜日コード
  SURYOSA_BUNRUI: 'KI073', // 数量差分類
  KAISHU_SHIHARAI_KB: 'KI074', // 回収支払区分
  KAISHU_SHIHARAI_HOHO_KB: 'KI075', // 回収支払方法区分
  DATA_CHECK_KB: 'KI076', // データチェック区分
  KESSAI_JOKEN_KB: 'KI077', // 決済条件区分
  SEIKYU_TAISHO_KB: 'KI078', // 請求対象区分
  SEIKYUSHO_TAISHO_KB: 'KI079', // 共通請求書対象区分
  TORIHIKI_KIJUN_KB: 'KI080', // 取引基準日区分
  KYUJITSU_SHORI_KB: 'KI081', // 休日処理区分
  SAITO_KEISAN_KYUJITSU_KB: 'KI082', // サイト日計算休日区分
  SHIMEBI_KB: 'KI083', // 締日区分
  SAITO_KB: 'KI084', // サイト区分
  TORIATSUKAI_KB: 'KI085', // 取扱区分
  UKEHARAI_ZANDAKA_KB: 'KI086', // 受払残高区分
  KAIGAI_KOBETSU_KB: 'KI087', // 会外個別区分
  TORIHIKISAKI_ZOKUSEI: 'KI088', // 取引先属性
  SHIHARAI_KUBUN: 'KI089', // 支払区分
  UCHIWAKE_SHUKEI_KB: 'KI090', // 金額内訳集計区分
  GAIBU_SETSUZOKUSAKI_ID: 'KI091', // 外部接続先ID
  URIAGE_SHUKKO_KB: 'KI092', // 売上出庫区分
  SHIWAKE_MEISAI_KB: 'KI093', // 仕訳明細区分
  DONAI_DOGAI_KB: 'KI094', // 道内道外区分
  KEIRI_RIYU_CD: 'KI095', // 経理理由コード
  KEIRI_JIKO_CD: 'KI096', // 経理事故コード
  GAIBU_RENKEI_KINO_ID: 'KI097', // 外部連携機能ID
  SHORI_TITLE: 'KI098', // 画面処理タイトル
  SO_CHOKU_KB: 'KI099', // 倉直区分
  HAISO_KEITAI: 'KI100', // 配送形態
  KAIKEI_TEISEI_KB: 'KI101', // 会計訂正区分
  NEBIKI_HEMPIN_KB: 'KI102', // 値引返品区分
  CHOHYO_SHURUI: 'KI103', // 帳票種類
  SHONIN_KAKUNIN_KB: 'KI104', // 承認確認区分
  TORIKOMI_RESULT: 'KI105', // 取込結果
  TANA_JOKYO_KB: 'KI106', // 棚卸状況区分
  DATA_RENKEI_TEISEI_KB: 'KI107', // データ連携訂正区分
  DATA_RENKEI_FLG: 'KI108', // データ連携フラグ
  JUCHU_STATUS: 'KI109', // 受注状態
  IDO_STATUS: 'KI110', // 移動状態
  MUKO_KB: 'KI111', // 無効区分
  NOHINSHO_KB: 'KI112', // 納品書区分
  MAINTENANCE_KB: 'KI113', // メンテナンス区分
  HATCHU_ZAIKO_SHUKKA_KB: 'KI114', // 発注在庫出荷区分
  JOTAI_KB: 'KI115', // 状態区分
  SAITO_SHIYO_KB: 'KI199', // サイト使用区分
  TANI_KB: 'KI204', // 単位区分
  SHOKUHIN_KA_CD: 'KI205', // 食品課コード
  HIMMOKU_TOKEI_KB_1: 'KI206', // 品目統計区分１
  HIMMOKU_TOKEI_KB_2: 'KI207', // 品目統計区分２
  HIMMOKU_TOKEI_KB_3: 'KI208', // 品目統計区分３
  HIMMOKU_TOKEI_KB_4: 'KI209', // 品目統計区分４
  HIMMOKU_TOKEI_KB_5: 'KI210', // 品目統計区分５
  TOKUISAKI_TOKEI_KB_1: 'KI211', // 得意先統計区分１
  TOKUISAKI_TOKEI_KB_2: 'KI212', // 得意先統計区分2
  TOKUISAKI_TOKEI_KB_3: 'KI213', // 得意先統計区分3
  TOKUISAKI_TOKEI_KB_4: 'KI214', // 得意先統計区分4
  TOKUISAKI_TOKEI_KB_5: 'KI215', // 得意先統計区分5
  NOHINSAKI_GYOTAI_KB: 'KI216', // 納品先業態区分
};

// 可・不可フラグ
export const KaFukaFlg = {
  FUKA: 0, // 不可
  KA: 1, // 可
};

// 無効フラグ
export const MukoFlg = {
  YUKO: 0, // 有効
  MUKO: 1, // 無効
};

// 端数区分
export const HasuKb = {
  SHISHAGONYU: 1, // 四捨五入
  KIRIAGE: 2, // 切り上げ
  KIRISUTE: 3, // 切り捨て
};

// 対象フラグ
export const TaishoFlg = {
  TAISHO: 0, // 対象
  TAISHO_GAI: 1, // 対象外
};

// 済フラグ
export const SumiFlg = {
  MI: 0, // 未
  SUMI: 1, // 済
};

// 有無フラグ
export const UmuFlg = {
  NASHI: 0, // 無
  ARI: 1, // 有
};

// PB区分
export const PbKb = {
  NB: 0, // NB
  PB: 1, // PB
  KOJO_B: 2, // 工場B
};

// 出荷区分
export const ShukkaKb = {
  ZAIKO_SHUKKA: 0, // 在庫出荷
  HATCHU_CHOKUSO: 1, // 発注・直送依頼
  TAJIGYOSHO: 2, // 他事業所依頼
};

// 使用区分
export const ShiyoKb = {
  SHIYOCHU: 0, // 使用中
  MISHIYO: 1, // 未使用
};

// 会内会外区分
export const KainaiKaigaiKb = {
  KAINAI: 0, // 会内
  KAIGAI: 1, // 会外
};

// 利用ランク
export const RiyoRank = {
  NASHI: 0, // 指定なし
  SHITEN_TANTOSHA: 1, // 支店担当者
  HONSHO_TANTOSHA: 2, // 本所担当者
  SHITEN_KANRISHA: 5, // 支店管理者
  HONSHO_KANRISHA: 6, // 本所管理者
  GAIBU_RIYOSHA: 9, // 外部利用者
  SYSTEM_KANRISHA: 99, // システム管理者
};

// 保守区分
export const HoshuKb = {
  ADD: 0, // 追加
  UPD: 1, // 変更
  DELETE: 2, // 削除
  DEL_CANCEL: 3, // 削除取消
};

// 精算内部取引区分
export const NaibuTorihikiKb = {
  GAIBU: 0, // 外部取引
  NAIBU: 1, // 内部取引
  NAIBU_SHISETSU: 2, // 内部取引（施設）
  NAIBU_SHOHI: 3, // 内部消費取引
  KASHOKUCHI: 4, // 課諸口
  SHOKUCHI_HI_FUKAZEI: 5, // 諸口（非／不課税）
};

// 回収サイト算出基準
export const KaishuSaitoKijun = {
  SHUKKA_YMD: 1, // 出荷日基準
  NOSHIN_YMD: 2, // 納品日基準
};

// 出力区分
export const OutputKb = {
  YES: 0, // 出力する
  NO: 1, // 出力しない
};

// 通知区分
export const TsuchiKb = {
  SHUDO: 0, // 手動
  MAIL: 1, // メール
  DATA: 2, // データ連携
};

// 倉庫個別区分
export const SokoKobetsuKb = {
  NASHI: 0, // なし
  NICHIREI: 1, // ニチレイ
  HOKURYO_SANGYO: 2, // 北菱産業
};

// 仕入先倉庫配送区分
export const ShiiresakiSokoHaisoKb = {
  NASHI: 0, // 指定なし
  JISHA: 1, // 自社便
  HIKITORI: 2, // 引取配送
  TAKKYUBIN: 3, // 宅急便
};

// 事業所区分
export const JigyoshoKb = {
  SHITEN: 0, // 支店
  HONSHO: 1, // 本所
};

// 重要フラグ
export const JuyoFlg = {
  TSUJO: 0, // 通常
  JUYO: 1, // 重要
};

// 按分基準
export const AnbunKijun = {
  NASHI: 0, // なし
  ZAIKO_SURYO: 11, // 在庫数量
  ZAIKO_JURYO: 12, // 在庫重量
  NYUKO_SURYO: 21, // 入庫数量
  SHUKKO_SURYO: 22, // 出庫数量
  NYUSHUKKO_SURYO: 23, // 入出庫数量
  NYUKO_JURYO: 24, // 入庫重量
  SHUKKO_JURYO: 25, // 出庫重量
  NYUSHUKKO_JURYO: 26, // 入出庫重量
  URIAGE_SURYO: 31, // 売上数量
  URIAGE_JURYO: 32, // 売上数量
};

// 摘要種類コード
export const TekiyoShuruiCd = {
  HONTAI: 1, // 本体
  SHOHIZEI: 2, // 消費税
};

// 採番コード
export const SaibanCd = {
  JUCHU_NO: 1, // 受注番号
  HATCHU_IRAI_NO: 2, // 発注依頼番号
  HATCHU_NO: 3, // 発注番号
  IDO_IRAI_NO: 4, // 在庫移動依頼番号
  ZAIKO_HIKIATE_NO: 5, // 在庫引当番号
  HIKIATE_NO: 6, // 引当番号
  SHUKKA_IRAI_NO: 7, // 出荷依頼番号
  HAISO_IRAI_NO: 8, // 配送依頼番号
  UNCHIN_NO: 9, // 運賃番号
  HASSO_ANNAI_NO: 10, // 発送案内番号
  SHUKKA_ANNAI_NO: 11, // 出荷案内番号
  SHUKKA_NO: 12, // 出荷番号
  NYUSHUKKO_NO: 13, // 入出庫番号
  NYUKO_KEKKA_NO: 14, // 入庫結果番号
  URIAGE_NO: 15, // 売上番号
  IKAN_NO: 16, // 移管番号
  SHIIRE_NO: 17, // 仕入番号
  KAKO_NO: 18, // 加工番号
  SHOGAKARI_NO: 19, // 諸掛番号
  SEIKYU_KANRI_NO: 20, // 請求管理番号
  DOKAI_YUSOHI_NO: 21, // 道外輸送費振替番号
  SEIKYUSHO_NO: 22, // 請求書番号
  TORIKOMI_NO: 23, // 取込番号
  TOKUISAKI_HATCHU_NO: 24, // 得意先発注番号
};

// ユーザ保守区分
export const UserHoshuKb = {
  FUKA: 0, // 不可
  MEISHO_ONLY: 1, // 名称変更のみ
  ALL_OK: 2, // 追加変更削除可
};

// 仕入先区分
export const ShiiresakiKb = {
  TSUJO: 0, // 通常仕入先
  KYORYOKU_KOJO: 1, // 協力工場
  HAISO_KAISHA: 2, // 配送会社
  //SHIHARAISAKI: 3, // 支払先(廃止)
};

// フラグ
export const Flg = {
  FLG_FALSE: 0, // しない
  FLG_TRUE: 1, // する
};

// オンライン区分
export const OnlineKb = {
  KAIKYOKU: 0, // 開局
  SAI_KAIKYOKU: 1, // 再開局
  HEIKYOKU: 6, // 閉局
  NICHIJI_SHIME_CHU: 8, // 日次締中
  NICHIJI_SHIME_SHURYO: 9, // 日次締終了
};

// 加食取扱区分
export const KashokuToriatsukaiKb = {
  SHIIRE: 1, // 仕入
  URIAGE: 2, // 売上
  IKAN_HARAIDASHI: 3, // 移管払出
  IKAN_UKEIRE: 4, // 移管受入
  KAKO: 7, // 加工
  GENKA_SANNYU: 8, // 原価算入
  HAMBAIHI: 9, // 販売費
  SHOHIZEI_SAGAKU: 91, // 消費税差額
  DOGAI_YUSOHI_HAIFU: 92, // 道外輸送費配賦
};

// 精算内部取扱区分
export const NaibuToriatsukaiKb = {
  GAIBU: 0, // 外部取引
  NAIBU: 1, // 内部取引
  NAIBU_SHISETSU: 2, // 内部取引（施設）
  NAIBU_SHOHI: 3, // 内部消費
  KASHOKUCHI: 4, // 課諸口
  SHOKUCHI: 5, // 諸口
  DOGAI_YUSO_HONSHO: 8, // 道外輸送本所振替
  DOGAI_YUSO_SHITEN: 9, // 道外輸送支店振替
};

// 移管取引区分
export const IkanTorihikiKb = {
  NASHI: 0, // なし
  IKAN_TORIHIKI: 1, // 移管取引
};

// 使用業種区分
export const ShiyoGyoshuKb = {
  SHOKUHINKA: 1, // 食品課
  ZAKKOKUKA: 2, // 雑穀課
};

// 消費税取引区分
export const ShohizeiTorihikiKb = {
  KAZEI_SHI: 11, // 課税仕入
  KAZEI_URI: 12, // 課税売上
  KAZEI_URI_MODOSHI: 18, // 課税売上戻し
  KAZEI_SHI_MODOSHI: 19, // 課税仕入戻し
  HIKAZEI_SHI: 21, // 非課税仕入
  HIKAZEI_URI: 22, // 非課税売上
  MENZEI_SHI: 23, // 免税仕入
  MENZEI_URI: 24, // 免税売上
  FIKAZEI: 30, // 不課税取引
  KEIGEN_KAZEI_SHI: 41, // 課税仕入（軽減税率）
  KEIGEN_KAZEI_URI: 42, // 課税売上（軽減税率）
  KEIGEN_KAZEI_URI_MODOSHI: 48, // 課税売上戻し（軽減税率）
  KEIGEN_KAZEI_SHI_MODOSHI: 49, // 課税仕入戻し（軽減税率）
};

// 仕訳摘要分類区分
export const ShiwakeTekiyoBunruiKb = {
  KEIRI_TEKIYO: 6, // 経理摘要
  KINGAKU_TEKIYO: 9, // 金額摘要
};

// データ発生区分
export const DataHasseiKb = {
  JUCHU_ENTRY: 11, // 受注入力
  JUCHU_ENTRY_GAI: 12, // 受注入力（会外）
  JUCHU_DATA_IMP: 13, // 受注データ取込
  SHUKKA_JUNBI: 21, // 出荷準備
  SHUKKA_JUNBI_GAI: 22, // 出荷準備（会外）
  SHUKKA_KAKUTEI: 23, // 出荷確定
  SHUKKA_ANNAI_IMP: 24, // 出荷案内データ取込
  SHUKKA_JISSEKI_UPD: 25, // 出荷実績更新
  URIAGE_ENTRY: 31, // 売上入力
  URIAGE_IKKATSU_KEIJO: 32, // 売上一括計上
  HATCHU_IRAI_ENTRY: 41, // 発注依頼入力
  HATCHU_DATA_SEISEI: 42, // 発注データ生成
  HATCHU_ENTRY: 43, // 発注入力
  HATCHU_KAKUTEI: 44, // 発注確定
  HASSO_ANNAI_IMP: 45, // 発送案内データ取込
  HASSO_ANNAI_ENTRY: 46, // 発送案内入力
  HASSO_ANNAI_ENTRY_GAI: 47, // 発送案内入力（会外）
  HASSO_JISSEKI_UPD: 48, // 発送実績更新
  HATCHU_CONFIRM_GAI: 49, // 発注確認（会外）
  NYUKO_ENTRY: 51, // 入庫入力
  NYUKO_KEKKA_IMP: 52, // 入庫結果データ取込
  NYUKO_JISSEKI_UPD: 53, // 入庫実績更新
  SHIIRE_ENTRY: 61, // 仕入入力
  SHIIRE_IKKATSU_KEIJO: 62, // 仕入一括計上
  SHIIRE_SEIKYU_IMP: 63, // 仕入請求データ取込
  SHIIRE_TANKA_IMP: 64, // 仕入単価データ取込
  KAKO_FURIKAE_ENTRY: 71, // 加工振替入力
  KAKO_FURIKAE_ENTRY_GAI: 72, // 加工振替入力（会外）
  SHOGAKARI_ENTRY: 81, // 諸掛入力
  ZAIKO_IDO_IRAI_ENTRY: 91, // 在庫移動依頼入力
  ZAIKO_IDO_IRAI_ENTRY_GAI: 92, // 在庫移動依頼入力（会外）
  NYUKO_DATA_IMP: 93, // 入庫データ取込
  TANAOROSHI_ENTRY: 111, // 棚卸入力
  TANAOROSHI_IMP: 112, // 棚卸データ取込
};

// 明細属性区分
export const MeisaiZokuseiKb = {
  TSUJO: 0, // 通常
  SAMPLE: 1, // サンプル
  GENBUTSU: 2, // 現物添付
};

// 課税区分
export const KazeiKb = {
  FUKAZEI: 1, // 不課税
  KAZEI_SOTOZEI: 4, // 課税（外税）
};

// 受払単位区分
export const UkeharaiTaniKb = {
  KINGAKU: 1, // 金額
  SURYO_KINGAKU: 2, // 数量、金額
  SURYO_TANKA_KINGAKU: 3, // 数量、単価、金額
};

// 承認フラグ
export const ShoninFlg = {
  MI_SHONIN: 0, // 未承認
  SHONIN: 1, // 承認
};

// 発注配送区分
export const HatchuHaisoKb = {
  CHOKUSO: 1, // 直送
  HIKITORI: 2, // 引取
};

// 入出庫区分
export const NyushukkoKb = {
  NYUKO: 1, // 入庫
  SHUKKO: 2, // 出庫
};

// 配送区分
export const HaisoKb = {
  HAISO: 1, // 配送
  HIKITORI: 2, // 引取
  TAKKYUBIN: 3, // 宅急便
};

// 請求先区分
export const SeikyusakiKb = {
  TOKUISAKI: 0, // 得意先
  SEIKYUSAKI: 1, // 請求先
  KYOTSU: 2, // 共通
};

// 品目種類コード
export const HimmokuShuruiCd = {
  KAITORIHIN: 1, // 買取品
  SHOHIZEI: 2, // 消費税
  KAKAKU_JOKEN: 3, // 価格条件
  CHOAIRYO: 4, // 帳合料（原簿単位）
  TOKUBETSU_BUBIKI: 5, // 特別歩引（原簿単位）
  HAMBAIHI: 6, // 販売費
  TORIHIKI_FUZUI_SHOGAKARI: 7, // 取引付随諸掛
};

// 受払区分
export const UkeHaraiKb = {
  HARAIDASHI: 1, // 払出
  UKEIRE: 2, // 受入
};

// 配送手配区分
export const HaisoTehaiKb = {
  JIBUSHO: 1, // 自部署
  BUTSURYU_KA: 2, // 物流課
  NICHIREI_LOGI: 3, // ニチレイロジＧ
  SATORUI_HAMBAI_KA: 4, // 砂糖類販売課
};

// ログ状況区分
export const LogKb = {
  NORMAL: 'N', // Normal
  INFORMATION: 'I', // Information
  WARNING: 'W', // Warning
  ERROR: 'E', // Error
  ABEND: 'A', // Abend
};

// 賞味期限表示フラグ
export const ShomiHyojiFlg = {
  YES: 0, // 表示する
  NO: 1, // 表示しない
};

// 請求区分
export const SeikyuKb = {
  MI: 0, // 未
  KARI: 1, // 仮
  CHUSHUTSU: 2, // 抽出中
  SHIME_ZUMI: 3, // 締済
};

// 取消フラグ
export const TorikeshiFlg = {
  MI: 0, // 未
  TORIKESHI: 1, // 取消
};

// 税率区分
export const ZeiritsuKb = {
  HYOJUN: 0, // 標準税率
  KEIGEN: 1, // 軽減税率
};

// 内訳区分
export const UchiwakeKb = {
  UNCHIN: 1, // 運賃
  TOKUBETSU_BUBIKI: 2, // 特別歩引
  CHOAIRYO: 3, // 帳合料
};

// 倉庫管理区分
export const SokoKanriKb = {
  JISHA: 0, // 自社管理
  TASHA: 1, // 他社管理
};

// 出来高区分
export const DekidakaKb = {
  DEKI: 0, // 出来
  TONYU: 1, // 投入
};

// メールID
export const MailId = {
  HAISO_IRAI: 1, // 配送依頼
  SHUKKA_ANNAI: 2, // 出荷案内
  NOHINSHO: 3, // 納品書
  NYUKO_YOTEI: 4, // 入庫予定
  HATCHU: 5, // 発注
  SEIKYUSHO: 6, // 請求書
  SHUKKA_IRAI: 7, // 出荷依頼
  PASSWORD_SAIHAKKO: 8, // パスワード再発行
};

// 仕入入庫区分
export const ShiireNyukoKb = {
  SHIIRE: 0, // 仕入のみ
  SHIIRE_NYUKO: 1, // 仕入・入庫
};

// 工場状態区分
export const KojoJotaiKb = {
  MI: 0, // 未確認
  KAKUNIN: 1, // 確認済
  HORYU: 2, // 保留
  SHUKKA: 3, // 出荷済
};

// 引当区分
export const HikiateKb = {
  MI: 0, // 未
  OK: 1, // OK
  TAISHO_GAI: 2, // 対象外
  NG: 9, // NG
};

// 旬区分
export const JunKb = {
  NASHI: 0, // なし
  JOJUN: 1, // 上旬
  CHUJUN: 2, // 中旬
  GEJUN: 3, // 下旬
};

// 引当エラー区分
export const HikiateErrKb = {
  NASHI: 0, // エラーなし
  SOKO_NASHI: 1, // 出荷倉庫未設定
  ZAIKO_NASHI: 2, // 在庫不足
  SHOMI_ZAIKO_NASHI: 3, // 指定賞味期限在庫不足
  NENSAN_ZAIKO_NASHI: 4, // 指定年産在庫不足
  SHUKKA_SHOMI_GYAKUTEN: 5, // 出荷済み賞味期限逆転
};

// 訂正区分
export const TeiseiKb = {
  MI: 0, // 未
  TORIKESHI: 1, // 取消
  TEISEI: 2, // 訂正
};

// 変更区分
export const HenkoKb = {
  MI: 0, // 未変更
  CHOKKIN: 1, // 直近
  KAKO: 2, // 過去
};

// 諸掛区分
export const ShogakariKb = {
  GENKA_SANNYU: 1, // 原価算入
  HAMBAIHI: 2, // 販売費
};

// 処理区分
export const ShoriKb = {
  ADD: 0, // 追加
  REFER: 1, // 参照
  UPD: 2, // 編集
  CANCEL: 3, // 取消
  COPY: 4, // 複写
  TEISEI: 5, // 訂正
  IKKATSU: 6, // 一括計上
  DEL_CANCEL: 7, // 削除取消
  TEISEI_CANCEL: 8, // 訂正取消
};

// 支払先区分
export const ShiharaisakiKb = {
  SHIIRESAKI: 0, // 仕入先
  SHIHARAISAKI: 1, // 支払先
  KYOTSU: 2, // 共通
};

// 移送元区分
export const IsoMotoKb = {
  KOMOKU_NO_SHITEI: 1, // 項目NO指定
  KOTEICHI: 2, // 固定値
  TOKUISAKI_HENKAN: 3, // 得意先変換マスタ
  HIMMOKU_HENKAN: 4, // 品目変換マスタ
  KEISAN_SHIKI: 5, // 計算式
  SUBSTR_B: 6, // SUBSTRB
};

// ファイル形式
export const FileKeishiki = {
  KOTEICHO: 1, // 固定長
  CSV_MIDASHI_ARI: 2, // CSV見出付
  CSV_MIDASHI_NASHI: 3, // CSV見出無
  TXT_MIDASHI_ARI: 4, // TXT見出付
  TXT_MIDASHI_NASHI: 5, // TXT見出無
  DOKUJI: 99, // 独自
};

// 伝送形式
export const DensoKeishiki = {
  FINET: 1, // FINET
  WEB_EDI: 2, // WEB_EDI
  HULFT: 3, // HULFT
  SHUDO: 99, // 手動
};

// 承認結果区分
export const ShoninKekkaKb = {
  MISHORI: 0, // 未処理
  SHONIN: 1, // 承認
  KYAKKA: 9, // 却下
};

// 計上単位区分
export const KeijoTaniKb = {
  KAKO_FURIKAE: 1, // 加工振替
  SHOGAKARI_GENKA: 2, // 諸掛（原価）
  SHOGAKARI_HAMBAIHI: 3, // 諸掛（販売費）
  SHIIRE: 4, // 仕入
  URIAGE: 5, // 売上
  IKAN_UKEIRE: 6, // 移管受入
  IKAN_HARAIDASHI: 7, // 移管払出
};

// 確認区分
export const KakuninKb = {
  MI: 0, // 未
  KARI: 1, // 仮
  SUMI: 2, // 済
};

// カレンダー識別コード
export const CalendarShikibetsuCd = {
  HI_KEIRI_BI: 1, // 非経理日
  FURIKOMI_HI_SHIHARAI_BI: 2, // 振込非支払日
  IPPAN_HI_SHIHARAI_BI: 3, // 一般非支払日
  KOBAI_IPPAN_HI_KAISHU_BI: 4, // 購買一般会員非回収日
  KOBAI_NYUDAI_HI_KASHU_BI: 5, // 購買乳代会員非回収日
  FURIKOMI_HI_KAISHU_BI: 6, // 振込非回収日
  IPPAN_HI_KAISHU_BI: 7, // 一般非回収日
  KUSHINREN_HI_FURIKOMI_BI: 8, // 北信連振込Ｓ非振込日
  KOBAI_KYOTSU: 10, // 購買共通カレンダー
  PEARL_RENDO: 11, // パール総合ホスト連動
  HI_KAIKYOKU_BI: 20, // 非開局日
};

// 曜日コード
export const YobiCd = {
  SUN: 1, // 日曜日
  MON: 2, // 月曜日
  TUE: 3, // 火曜日
  WED: 4, // 水曜日
  THU: 5, // 木曜日
  FRI: 6, // 金曜日
  SAT: 7, // 土曜日
};

// 数量差分類
export const SuryosaBunrui = {
  BAIKYAKU_MI_KEIRI: 1, // 売却未経理
  SHIIRE_MI_KEIRI: 2, // 仕入未経理
  AZUKARI_HIN: 3, // 預かり品
  JIKO_HIN: 4, // 事故品
};

// 回収支払区分
export const KaishuShiharaiKb = {
  NASHI: 0, // なし
  KAISHU: 1, // 回収
  SHIHARAI: 2, // 支払
};

// 回収支払方法区分
export const KaishuShiharaiHohoKb = {
  GENKIN: '1', // 現金
  FURIKOMI: '2', // 振込
  TEGATA: '3', // 手形
  FURIKAE: '7', // 振替
  SOSAI_GENKIN: 'B', // 相殺・現金
};

// データチェック区分
export const DataCheckKb = {
  OK: 0, // OK
  WARNING: 1, // 警告
};

// 決済条件区分
export const KessaiJokenKb = {
  SHINADAI: 1, // 品代
  SHOGAKARI: 2, // 諸掛
};

// 請求対象区分
export const SeikyuTaishoKb = {
  KONKAI: 0, // 今回請求
  JIKAI: 1, // 次回請求
  ZENKAI: 2, // 請求対象外
};

// 共通請求書対象区分
export const SeikyushoTaishoKb = {
  TAISHO: 1, // 対象
  HI_TAISHO: 2, // 非対象
};

// 取引基準日区分
export const TorihikiKijunKb = {
  NASHI: 0, // 基準日なし
  NYUKA_BI: 1, // 入荷日
  SHUKKA_BI: 2, // 出荷日
  KEIRI_BI: 3, // 経理日
  KESSAI_BI: 4, // 決裁日
};

// 休日処理区分
export const KyujitsuShoriKb = {
  NASHI: 0, // 休日処理なし
  KURIAGE: 1, // 銀行休日・日祭日繰上
  KURISAGE: 3, // 銀行休日・日祭日繰下
};

// サイト日計算休日区分
export const SaitoKeisanKyujitsuKb = {
  NASHI: 0, // 休日処理なし
  GINKO_JOGAI: 1, // 銀行休日・日祭日除く
  SAIJITSU_JOGAI: 2, // 日祭日除く
};

// 締日区分
export const ShimebiKb = {
  TSUDO: 1, // 都度
  SHITEI_BI: 2, // 指定日
  SHU_SHIME: 3, // 週締
  TSUKI_SHIME: 4, // 月締
};

// サイト区分
export const SaitoKb = {
  NISSU: 1, // 日数
  GAPPI: 2, // 月日
  SHITEI_GAPPI: 3, // 指定月日
};

// 取扱区分
export const ToriatsukaiKb = {
  KAITORI: 1, // 買取
  JUTAKU: 2, // 受託
  CHOKUSO: 3, // 直送
  KYOKEI: 4, // 共計
  GENRYO: 5, // 原料
};

// 受払残高区分
export const UkeharaiZandakaKb = {
  KAITORI_IGAI: 0, // 買取品以外
  KOBAI_HIN: 1, // 購買品
  HAMBAI_HIN: 2, // 販売品
  TEMPO_HIN: 3, // 店舗品
  SEIHIN: 4, // 製品
  NAIBU_SHIIRE_URIAGE: 5, // 内部仕入売上
  NAIBU_IKAN: 6, // 内部移管
};

// 会外個別区分
export const KaigaiKobetsuKb = {
  IPPAN: 0, // 一般
  BUTSURYU_KA: 1, // 物流課
  SATORUI_HAMBAI_KA: 2, // 砂糖類販売課
  NICHIREI_LOGI: 3, // ニチレイロジＧ
};

// 取引先属性
export const TorihikisakiZokusei = {
  KAIIN_SOGO_NOKYO: 10, // 会員総合農協
  KAIIN_KOIKI_NOKYO: 11, // 会員広域農協連
  KAIIN_RENGOKAI: 12, // 会員連合会
  KAIIN_SONOTA_NOKYO: 13, // 会員その他農協
  JUN_KAIIN: 19, // 準会員
  IPPAN_TORIHIKI_SONOTA: 20, // 一般取引先（その他）
  TOFUKEN_KEIZAIREN: 21, // 他都府県経済連
  KEITO_INGAI: 22, // 系統員外
  INGAI_SOGO_NOKYO: 23, // 員外総合農協
  INGAI_SONOTA_NOKYO: 24, // 員外その他農協
  NOGYO_KYOSAI_KUMIAI: 25, // 農業共済組合
  GAIKAKU_DANTAI: 26, // 外郭団体
  KAIIN_NOKYO_KAISHA: 27, // 会員農協関係関連会社
  INGAI_RENGOKAI: 28, // 員外連合会
  KANKOCHO: 29, // 官公庁
  HOKUREN: 30, // ホクレン
  JIGYOSHO: 31, // 事業所
  HONBU: 32, // 統括本部
  BU: 33, // 部
  KA: 34, // 課
  SHISETSU: 35, // 施設
  KYODO_KAISHA_1: 40, // 共同会社Ⅰ
  KYODO_KAISHA_2: 41, // 共同会社Ⅱ
  KANREN_KAISHA: 42, // 関連会社
  KANREN_DANTAI: 43, // 関連団体
  SONOTA_DANTAI: 44, // その他関連団体
  SHOGUCHI: 50, // 諸口
  SHOGUCHI_JIGYOSHO: 51, // 諸口（事業所）
  SHOGUCHI_HONBU: 52, // 諸口（統括本部）
  SHOGUCHI_BU: 53, // 諸口（部）
  SHOGUCHI_KA: 54, // 諸口（課）
  SHOGUCHI_SHISETSU: 55, // 諸口（施設）
};

// 支払区分
export const ShiharaiKubun = {
  NASHI: 0, // 無
  SHIHARAI_YOTEI: 1, // 支払予定
  JITSU_SHIHARAI: 2, // 実支払
};

// 金額内訳集計区分
export const UchiwakeShukeiKb = {
  MEISAI: 0, // 明細
  UNCHIN: 1, // 運賃
  TOKUBETSU_BUBIKI: 2, // 特別歩引
  CHOAIRYO: 3, // 帳合料
  SHOHIZEI_GAKU: 4, // 消費税額
  UCHIWAKE: 9, // 内訳
};

// 外部接続先ID
export const GaibuSetsuzokusakiId = {
  NICHIREI_LOGI: 1, // ニチレイ・ロジスティクス
  MITSUBISHI_SHOKUHIN: 2, // 三菱食品
  NIPPON_ACCESS: 3, // 日本アクセス
  NACX: 4, // ナックス
  ITOCHUSHOJI: 5, // 伊藤忠商事
  MITSUI_FOODS: 6, // 三井食品
};

// 売上出庫区分
export const UriageShukkoKb = {
  URIAGE: 0, // 売上のみ
  URIAGE_SHUKKO: 1, // 売上・出庫
};

// 仕訳明細区分
export const ShiwakeMeisaiKb = {
  SHINADAI: 1, // 品代
  IKAN_HARAIDASHI_SHINADAI: 2, // 移管払出品代
  IKAN_UKEIRE_SHINADAI: 3, // 移管受入品代
  SHOHIZEI: 4, // 消費税
  BUBIKI_KINGAKU: 5, // 歩引金額
  TOKUBETSU_BUBIKI_KINGAKU: 6, // 特別歩引金額
  CHOAIRYO: 7, // 帳合料
  TONYU: 8, // 投入
  DEKIDAKA: 9, // 出来高
  SHOHIZEI_SAGAKU: 10, // 消費税（消費税差額用）
  SHOGAKARI_KINGAKU: 11, // 諸掛金額
  SHOGAKARI_ZEI_KINGAKU: 12, // 諸掛消費税金額
  KOJO_SHOGAKARI: 13, // 控除諸掛
};

// 道内道外区分
export const DonaiDogaiKb = {
  DONAI: 0, // 道内
  DOGAI: 1, // 道外
};

// 経理理由コード
export const KeiriRiyuCd = {
  KINGAKU_SURYO_TANKA_SOI: 1, // 金額・数量・単価相違
  HIMMEI_SOI: 2, // 品名相違
  SAITO_SOI: 3, // サイト相違
  NYUKA_SHUKKA_SOI: 4, // 入荷・出荷日相違
  TORIHIKI_SAKI_SOI: 5, // 取引先相違
  SONOTA: 7, // その他
  SEISAN_KAKUTEI: 8, // 精算確定
};

// 経理事故コード
export const KeiriJikoCd = {
  SAITO_HENKO: 1, // サイト変更
  YOSHIN_GENDOWAKU_CHOKA: 2, // 与信限度枠超過
  MOTODEN_NASHI: 3, // 元伝なし
  TANAOROSHI_SASON_SAEKI: 4, // 棚卸差損・差益
  NEBIKIRITSU_CHOKA: 5, // 値引率超過
  SONOTA: 6, // その他
  ZAIKO_SHUSEI: 7, // 在庫修正
};

// 外部連携機能ID
export const GaibuRenkeiKinoId = {
  HAISO_IRAI: 1, // 配送依頼
  SHUKKA_ANNAI: 2, // 出荷案内
  NOHINSHO: 3, // 納品書
  NYUKO_YOTEI: 4, // 入庫予定
  HATCHU: 5, // 発注
  SEIKYUSHO: 6, // 請求書
  SHUKKA_IRAI: 7, // 出荷依頼
  EDI_S_ANAI_ITOCHU: 8, // EDI出荷案内（伊藤忠）
  EDI_S_ANAI_NUX_NAKA: 9, // EDI出荷案内（ナックスナカムラ）
  EDI_S_ANAI_MITSU_SHOKU: 10, // EDI出荷案内（三菱食品）
  HATCHU_CONFIRM: 11, // 発注確認
  JUCHU_DATA_IMP: 101, // 受注データ取込
  SHUKKA_ANNAI_IMP: 201, // 出荷案内データ取込
  NYUKO_KEKKA_IMP: 301, // 入庫結果データ取込
  HASSO_ANNAI_IMP: 401, // 発送案内データ取込
  NYUKO_DATA_IMP: 501, // 入庫データ取込
  TANAOROSHI_IMP: 601, // 棚卸データ取込
  SHIIRE_TANKA_IMP: 701, // 仕入単価データ取込
};

// 画面処理タイトル
export const ShoriTitle = {
  ADD: 0, // 【追加】
  REFER: 1, // 【照会】
  UPD: 2, // 【修正】
  CANCEL: 3, // 【取消】
  COPY: 4, // 【追加】
  TEISEI: 5, // 【訂正】
  IKKATSU: 6, // 【一括計上】
  DEL_CANCEL: 7, // 【修正】
  TEISEI_CANCEL: 8, // 【訂正・取消】
};

// 倉直区分
export const SoChokuKb = {
  SOIRI: '1', // 倉入
  CHOKUSO: '2', // 直送
  SO_TORIHIKI: '3', // 倉取引
  CHOKUSO_TORIHIKI: '4', // 直送取引
};

// 配送形態
export const HaisoKeitai = {
  CHOKUSO_KEISHIKI_SOIRI: 0, // 直送形式の倉入
  SOIRI_KEISHIKI_CHOKUSO: 1, // 倉入形式の直送
  TODOKESAKI_ARI: 3, // 届先有り
};

// 会計訂正区分
export const KaikeiTeiseiKb = {
  MI: 0, // 未
  TORIKESHI: 1, // 取消
  TORIKESHIGO_TEISEI: 2, // 取消後の訂正
};

// 値引返品区分
export const NebikiHempinKb = {
  TSUJO: 0, // 通常
  NEBIKI: 1, // 値引
  HEMPIN: 2, // 返品
};

// 帳票種類
export const ChohyoShurui = {
  JUCHU_LIST: 0, // 受注リスト
  HAISO_IRAISHO: 1, // 配送依頼書
  SHUKKO_IRAISHO: 2, // 出庫依頼書
  SHUKKA_ANNAISHO: 3, // 出荷案内書
  NOHINSHO: 4, // 納品書
  URIAGE_LIST: 5, // 売上リスト
  HATCHUSHO: 6, // 発注書
  SHIIRE_LIST: 7, // 仕入リスト
  NYUSHUKKO_LIST: 8, // 入出庫リスト
  SEIKYU_SHO: 9, // 請求書
  SEIKYU_LIST: 10, // 請求一覧表
  IDOCHU_ZAIKO_LIST: 11, // 輸送途上証明書
  FUFUGOHYO: 12, // 不符合表
  TANAOROSHI_KINYUHYO: 13, // 棚卸記入表
  ZAIKO_TANAOROSHIHYO: 14, // 在庫品棚卸表
  KEIJO_LIST: 15, // 計上リスト
  KAKUTEI_GEMBO: 16, // 確定原簿
  UNSO_SASHIZUSHO: 17, // 運送指図書
  JUCHU_UKESHO: 18, // 受注請書
  SONOTA: 99, // その他
};

// 承認確認区分
export const ShoninKakuninKb = {
  SHONIN: 1, // 承認
  KAKUNIN: 2, // 確認
};

// 取込結果
export const TorikomiResult = {
  OK: 1, // OK
  WARNING: 2, // 警告
  NG: 9, // NG
};

// 棚卸状況区分
export const TanaJokyoKb = {
  MI: 0, // 未
  NYURYOKU_CHU: 1, // 入力中
  SUMI: 2, // 済
};

// データ連携訂正区分
export const DataRenkeiTeiseiKb = {
  TSUJO: 0, // 通常
  TORIKESHI: 1, // 取消
};

// データ連携フラグ
export const DataRenkeiFlg = {
  NASHI: 0, // なし
  NICHIREI_LOGI: 1, // ニチレイロジ
};

// 受注状態
export const JuchuStatus = {
  KAKUNIN_CHU: 0, // 受注確認中
  UKETUKE_ZUMI: 1, // 受注受付済
  JUNBI_CHU: 2, // 出荷準備中
  SHUKKA_KONZAI: 3, // 出荷混在
  SHUKKA_ZUMI: 4, // 出荷済
  TORIKESHI: 9, // 取消済
};

// 移動状態
export const IdoStatus = {
  UKETUKE_ZUMI: 1, // 受付済
  JUNBI_CHU: 2, // 出荷準備中
  SHUKKA_ZUMI: 4, // 出荷済
};

// 無効区分
export const MukoKb = {
  YUKO: 0, // 有効
  MUKO: 1, // 無効
};

// 納品書区分
export const NohinshoKb = {
  SEIKYUSAKI: 0, // 請求先用
  TOKUISAKI: 1, // 得意先用
  SEI_TOKU_BOTH: 2, // 請求先・得意先用両方
};

// メンテナンス区分
export const MaintenanceKb = {
  NASHI: 0, // なし
  KIKAN_SAKUJO: 1, // 期間削除
  KIKAN_TAIHI: 2, // 期間退避
};

// 発注在庫出荷区分
export const HatchuZaikoShukkaKb = {
  HATCHU: 0, // 発注
  ZAIKO: 1, // 在庫
};

// 状態区分
export const JotaiKb = {
  KAKUNIN_CHU: 0, // 確認中
  UKETSUKE_ZUMI: 1, // 受付済
  KAKUTEI: 2, // 確定済
  HATCHU_SEISEI: 3, // 発注生成済
  HATCHU_TEHAI: 4, // 発注手配済
  SHUKKA_JUNBI: 5, // 出荷準備中
  SHUKKA_TEHAI: 6, // 出荷手配済
  SHUKKA_KONZAI: 7, // 出荷混在
  SHUKKA_ZUMI: 8, // 出荷済
  URIAGE_SEISEI: 90, // 売上生成済
  TORIKESHI: 99, // 取消済
};

// サイト使用区分
export const SaitoShiyoKb = {
  MISHIYO: 0, // サイト未使用
  TSUCHI_ARI: 1, // サイト使用（メール通知あり）
  TSUCHI_NASHI: 2, // サイト使用（メール通知なし）
  CSV: 3, // CSV出力
};

// 内部取引取引先
export const NaibuTorihiki = {
  NAIBU_1: '08481', // 内部取引１（内部得意先）
  NAIBU_2: '08482', // 内部取引２（内部消費）
  NAIBU_3: '08483', // 内部取引３（課諸口）
  NAIBU_4: '08484', // 内部取引４（諸口（非／不課税））
  NAIBU_5: '08485', // 内部取引５
};

// 処理ステータス
export const OutStatus = {
  NORMAL: 0, // 正常終了
  ABEND: -1, // 異常終了
  EXCLUSIVE_ERR: 1, // 排他エラー
  CHECK_ERR: 2, // チェックエラー
  ONLINE_CHECK_ERR: 3, // オンラインチェックエラー
  GENZAI_YMD_CHECK_ERR: 4, // 現在日付チェックエラー
};

// 色
export const Color = {
  GRAY: '#E5E5E5', // 灰色
  CREAM: '#FAFFC1', // クリーム色
  BLUE: '#1976D2', // 青色
  RED: '#D32F2F', // 赤色
  GREEN: '#04A246', // 緑色
};

// 品目種類パターン
export const HimmokuShuruiPtn = {
  KAITORIHIN_ONLY: 1, // 買取品のみ
  SHOGAKARI_ONLY: 2, // 取引付随諸掛のみ
  KAITORI_ZEI_JOKEN_HAMBAI: 3, // 買取品・消費税・価格条件・販売費
  SHOG_GENKA_SANNYU: 4, // 諸掛原価算入
  SHOG_HAMBAIHI: 5, // 諸掛販売費
};

// ワイルドカード品目
export const WildCardHimmoku = {
  SHOKUHINKA_HIM: 'B44000', // 食品課品目
  ZAKKOKUKA_HIM: 'B29000', // 雑穀課品目
};

// 日次関係
export const NichijiKankei = {
  KAISHU_SHIHA_SOSHIKI_CD: '4119', // 回収支払組織コード 
  KAKO_TONYU_KINGAKU_CD: '178', // 加工投入金額コード
  DOGAI_YUSO_AITESAKI: '08481148', // 道外輸送相手先
  DOGAI_YUSO_AITE_GYOSHU: '24', // 道外輸送相手業種
};

// 計上リスト出力パターン
export const KeijoListOutPtn = {
  KEIJO_LIST: 0, // 計上リスト
  KEIJO_ERROR_LIST: 1, // 計上エラーリスト
};

// 事業所コード
export const JigyoshoCd = {
  DOO_SHITEN: 22, // 道央支店
};

// 組織コード
export const SoshikiCd = {
  DOO_SHITEN: 4431, // 道央支店
  HONSHO: 4137, // 本所
};

// 収支管理品目コード
export const ShushiKanriHimmokuCd = {
  SHOHIZEI_SAGAKU_SHOKUHIN: 174898, // 消費税差額（食品課）
  SHOHIZEI_SAGAKU_ZAKKOKU: 255023, // 消費税差額（雑穀課）
};

// 諸掛摘要コード
export const ShogakariTekiyoCd = {
  DOGAI_YUSOHI: 50, // 道外輸送費
};

// 配賦種類
export const HaifuShurui = {
  KOBUKUROMAME: 11, // 小袋豆
  KATAKURIKO: 12, // 片栗粉
  KANZUME: 13, // 缶詰
  REITO_SHOKUHIN: 14, // 冷凍食品
  RETORUTO_SHOKUHIN: 15, // レトルト食品
};

// チェック結果
export const CheckResult = {
  MI: 0, // 未
  OK: 1, // OK
  WARNING: 2, // 警告
  NG: 9, // NG
};

// 出力対象区分
export const ShutsuryokuTaishoKb = {
  SEIKYUSHO: 0, // 請求書
  SEIKYUSHO_HIKAE: 1, // 請求書控え
};

// 請求書再発行区分
export const SeikyushoSaihakkoKb = {
  SHOKAI_HAKKO: 0, // 初回発行
  SAIHAKKO: 1, // 再発行
};

// 連動データ種別
export const RendoDataType = {
  MEISHO_JUSHO_MST: 'A1', // 名称住所マスタ
  CALENDAR_DATA_MST: 'A2', // カレンダーデータマスタ
  SHUSHI_KANRI_HIMMOKU_MST: 'A3', // 収支管理品目マスタ
  KANREN_AITESAKI_MST: 'A4', // 関連先相手マスタ
  KESSAI_JOKEN_MST: 'A5', // 決済条件マスタ
  SAITO_JOKEN_MST: 'A6', // サイト条件マスタ
  HYOKA_TANKA_DATA: 'A9', // 評価単価データ
  TANAOROSHI_HYO_DATA: 'AA', // 棚卸表データ
  KAIKEI_IF_DATA: 'A7', // 会計IFデータ
  ERROR_INFO_DATA: 'A8', // エラー情報データ
};

// 会計IFデータ内種別
export const KaikeiIfDataType = {
  HEADER: 'A7', // ヘッダ
  DETAIL_1: 'A7', // 明細１
  DETAIL_2: 'A7', // 明細２
  FOOTER: 'ZZ', // フッタ
};

// 承認マスタ区分
export const ShoninMstKb = {
  HIMMOKU_MST: 20, // 品目マスタ
  TOKUISAKI_MST: 80, // 得意先マスタ
  TOKUISAKI_CHOAIRITSU_MST: 90, // 得意先帳合率マスタ
  NOHINSAKI_MST: 100, // 納品先マスタ
  SHIIRESAKI_MST: 110, // 仕入先マスタ
  SOKO_MST: 160, // 倉庫マスタ
};

// 在庫照会合算区分
export const ZaikoShokaiGassanKb = {
  GASSAN_NASHI: 0, // 合算なし
  NENSAN: 1, // 年産
  NENSAN_SHOMI_KIGEN: 2, // 年産・賞味期限
  SOKO: 3, // 倉庫
};

// カテゴリー
export const Category = {
  NENDO: 1, // 年度
  CHOHYO_TYPE: 2, // 帳票種類
};

// 調整区分
export const ChoseiKb = {
  SURYO: 1, // 数量
  HASU: 2, // 端数
};

// 棚卸表出力区分
export const TanaShutsuryokuKb = {
  JIGYOSHO_SOKO: 0, // 事業所倉庫別
  JIGYOSHO_ALL: 1, // 全事業所
};

// 予測期間区分
export const YosokuKikanKb = {
  YOKU_GETSU: 1, // 翌月・翌々月
  NENKAN: 2, // 年間
};

// 日付区分
export const YmdKb = {
  SHUKKA_YMD: 1, // 出荷日
  NOHIN_YMD: 2, // 納品日
};

// *****  コンスタント変数 *****
export const SUPER_USER = 999999; // スーパーユーザ
export const NYUKO_NO_NONE = '-'; // 入庫NO未指定
export const ALL_TORIATSUKAI_HIM_CD = 'ALL'; // 全取扱品目コード
export const JUCHU_LIMIT_TIME = 1100; // 翌日受注可能時刻
